"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _reactRouterDom = require("react-router-dom");

var _usageTracker = _interopRequireDefault(require("../../lib/usageTracker"));

var _ChecklistPage = _interopRequireDefault(require("./ChecklistPage"));

var _TrialCtaPage = _interopRequireDefault(require("./TrialCtaPage"));

var _LoadingPage = _interopRequireDefault(require("./LoadingPage"));

var _MobilePage = _interopRequireDefault(require("./MobilePage"));

var _OverallPage = _interopRequireDefault(require("./OverallPage"));

var _PerformancePage = _interopRequireDefault(require("./PerformancePage"));

var _SecurityPage = _interopRequireDefault(require("./SecurityPage"));

var _SeoPage = _interopRequireDefault(require("./SeoPage"));

var _ShareBanner = _interopRequireDefault(require("../ShareBanner"));

var _OverallGrade = _interopRequireDefault(require("../sidepanel/OverallGrade"));

var _GraderActionCreator = _interopRequireDefault(require("../../actions/GraderActionCreator"));

var _PreviewActionCreator = _interopRequireDefault(require("../../actions/PreviewActionCreator"));

var _MainToolBar = _interopRequireDefault(require("../header/MainToolBar"));

var _Grader = require("../../selectors/Grader");

var _default = function _default() {
  var dispatch = (0, _reactRedux.useDispatch)();
  var websiteGrade = (0, _reactRedux.useSelector)(_Grader.getWebsiteGrade);

  var _useParams = (0, _reactRouterDom.useParams)(),
      websiteUrl = _useParams.websiteUrl;

  var loadWebsiteGrade = function loadWebsiteGrade() {
    dispatch(_GraderActionCreator.default.getGrade(websiteUrl));
    dispatch(_PreviewActionCreator.default.previewWebsite(websiteUrl));
  };

  (0, _react.useEffect)(function () {
    _usageTracker.default.logView('Results');

    loadWebsiteGrade();
    return function () {
      return dispatch(_GraderActionCreator.default.resultsPageUnmounted());
    };
  }, []);

  var renderLoading = function renderLoading() {
    return _react.default.createElement(_LoadingPage.default, {
      websiteUrl: websiteUrl
    });
  };

  var renderResults = function renderResults() {
    return _react.default.createElement("div", {
      "data-test-id": "results-page",
      className: "column-container"
    }, _react.default.createElement("div", {
      className: "left-column"
    }, _react.default.createElement(_OverallGrade.default, {
      websiteGrade: websiteGrade
    })), _react.default.createElement("div", {
      className: "right-column"
    }, _react.default.createElement(_MainToolBar.default, null), _react.default.createElement(_OverallPage.default, {
      websiteGrade: websiteGrade
    }), _react.default.createElement(_PerformancePage.default, {
      websiteGrade: websiteGrade
    }), _react.default.createElement(_SeoPage.default, {
      websiteGrade: websiteGrade
    }), _react.default.createElement(_MobilePage.default, {
      websiteGrade: websiteGrade
    }), _react.default.createElement(_SecurityPage.default, {
      websiteGrade: websiteGrade
    }), _react.default.createElement(_ChecklistPage.default, {
      websiteGrade: websiteGrade
    }), _react.default.createElement(_ShareBanner.default, null), _react.default.createElement(_TrialCtaPage.default, {
      websiteUrl: websiteUrl
    })));
  };

  if (websiteGrade.get('loading')) {
    return renderLoading(websiteGrade);
  } else {
    return renderResults(websiteGrade);
  }
};

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/pages/ResultsPage.js
// module id = 258
// module chunks = 0